import * as actionTypes from './actionTypes'

export const profile = (state = {
  data: {},
  isFetching: true,
  error: null,
  stagesResult: true
}, action) => {
  switch (action.type) {
    case actionTypes.PROFILE_REQUEST:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false,
        error: null,
      };
    case actionTypes.PROFILE_RECEIVE:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        didInvalidate: false,
        error: null,
      };
    case actionTypes.PROFILE_ERROR:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        error: action.error || action.errors,
      };
    case actionTypes.PROFILE_INVALIDATE:
      return {
        ...state,
        didInvalidate: true,
        error: null,
      };
    case actionTypes.PROFILE_UPDATE_STAGES_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case actionTypes.PROFILE_UPDATE_STAGES_RECEIVE:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        stagesResult:  action.result
      };
    case actionTypes.PROFILE_UPDATE_STAGES_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    case actionTypes.PROFILE_CLEAR_STAGES_RESULT:
      return {
        ...state,
        stagesResult: true
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/profile/reducers.js